const HEADER_PATTERN = /^(#{1,3}) (.*)$/
const BULLET_PATTERN = /^• (.*)$/
const NUMBERED_PATTERN = /^\d+\. (.*)$/

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function renderInline(text: string): string {
  return escapeHtml(text)
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
}

export function renderMarkdownPreview(content: string): string {
  const lines = content.split('\n')
  const html: string[] = []
  let listType: 'ul' | 'ol' | null = null

  const closeList = () => {
    if (listType) {
      html.push(`</${listType}>`)
      listType = null
    }
  }

  for (const line of lines) {
    const headerMatch = line.match(HEADER_PATTERN)
    const bulletMatch = line.match(BULLET_PATTERN)
    const numberedMatch = line.match(NUMBERED_PATTERN)

    if (headerMatch) {
      closeList()
      const level = headerMatch[1].length
      html.push(`<h${level}>${renderInline(headerMatch[2])}</h${level}>`)
    } else if (bulletMatch) {
      if (listType !== 'ul') {
        closeList()
        html.push('<ul>')
        listType = 'ul'
      }
      html.push(`<li>${renderInline(bulletMatch[1])}</li>`)
    } else if (numberedMatch) {
      if (listType !== 'ol') {
        closeList()
        html.push('<ol>')
        listType = 'ol'
      }
      html.push(`<li>${renderInline(numberedMatch[1])}</li>`)
    } else {
      closeList()
      html.push(line.trim() === '' ? '<br>' : `<p>${renderInline(line)}</p>`)
    }
  }
  closeList()

  return html.join('')
}
